import { TooltipedTextComponent, TooltipedTextComponentProps } from 'commons/components/tooltiped-text';
import { TOOTLTIP_TABLE_ROW_MOUNT_DELAY_MS } from '../custom-table.constants';

interface TooltipedCustomFieldCellProps extends Omit<
    TooltipedTextComponentProps,
    'i18nKey' | 'i18nValues' | 'tooltipText' | 'mountDelayMs'
> {
    value: string;
    tooltipText?: string;
}

export const TooltipedCustomFieldCell = ({ value, tooltipText, ...props }: TooltipedCustomFieldCellProps) => (
    <TooltipedTextComponent
        {...props}
        i18nKey="<tooltip>{{name}}</tooltip>"
        tooltipText={tooltipText ?? value}
        i18nValues={{ name: value }}
        mountDelayMs={TOOTLTIP_TABLE_ROW_MOUNT_DELAY_MS}
    />
);
